import { useQuery } from "@tanstack/react-query";
import CreateNewStamp from "./CreateNewStamp";
import { stampService } from "services";
import ViewDetailStamp from "views/Admin/Stamps/ViewDetailStamp";
import { API } from "common";

const Stamps = (props) => {
	const { data, isLoading: isLoadingStamp } = useQuery({
		queryKey: [API.QUERY_KEY_ADMIN_STAMPS],
		queryFn: async () => {
			try {
				return await stampService.getDetail();
			} catch (error) {
				console.log("error :>> ", error);
			}
		},
	});

	if (isLoadingStamp) {
		return null;
	}

	if (data) {
		return <ViewDetailStamp data={data} {...props} />;
	} else {
		return <CreateNewStamp {...props} />;
	}
};

export default Stamps;
